export default __webpack_public_path__ + "static/media/order-recieve.de2438c5.wav";